import { render, staticRenderFns } from "./NumbersSection.vue?vue&type=template&id=0b2efde9&scoped=true"
import script from "./NumbersSection.vue?vue&type=script&lang=js"
export * from "./NumbersSection.vue?vue&type=script&lang=js"
import style0 from "./NumbersSection.vue?vue&type=style&index=0&id=0b2efde9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2efde9",
  null
  
)

export default component.exports